import sctBnbCakeLp from "../abis/development/sctBnb/cakeLp";

const host = "https://bscscan.com/address";

export default [
  {
    name: "SCT-BNB Cake LP",
    type: "bnb",
    contractAddress: "0xa332ef54aa95d801e633e63f2e94beddaf12409b",
    minApr: 159,
    abi: sctBnbCakeLp.abi,
    url: `${host}/0xa332ef54aa95d801e633e63f2e94beddaf12409b`,
    decimals: 18,
  },
];
